import { Component, OnInit, OnDestroy, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';

import { LoaderService } from './loader.service';
import { LoaderState } from './loader';

@Component({
    selector: 'sf-loader',
    templateUrl: 'loader.component.html',
    styleUrls: ['loader.component.css'],
    encapsulation:ViewEncapsulation.None

})
export class LoaderComponent implements OnInit {

    show = false;

    private subscription: Subscription;

    constructor(
        private loaderService: LoaderService,
        private changeDetector : ChangeDetectorRef
    ) { }

    ngOnInit() {
        this.subscription = this.loaderService.loaderState
            .subscribe((state: LoaderState) => {
                this.show = state.show;
            });
    }

    ngOnDestroy() {
        this.show = false;
        this.subscription.unsubscribe();
    }

    ngAfterViewChecked(){
        this.changeDetector.detectChanges();
      }
}
